const styles = (theme) => ({
    container: {
        padding: '24px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    input: {
        margin: '10px 0',
        width: '49%!important'
    },
    register: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        marginTop: '10px'
    },
    signin: {
        display: 'flex',
        width: '70%',
        justifyContent: 'center',
        marginTop: '10px'
    },
    container1: {
        padding: '24px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    loginInput: {
        margin: '10px 0',
        width: '70%!important'
    }
});

export default styles;
